import { flattenObject, getDateString, daysUntilDate } from '../../utilities';
import { getPlanByLicense } from '../../settings/pricing-options';

export const getRowValue = (key, item) => {
  const value = item[key];
  switch (key) {
    case 'full_name':
      // This is only used on the stats pages right now.
      if (item.account_status === 'invited') {
        return 'Invite pending';
      }
      return `${item.given_name} ${item.family_name}`;
    case 'last_login_at':
    case 'admin_last_login': {
      if (!value) return { sortable: '', visible: '' };
      const date = new Date(value);
      return {
        sortable: date.valueOf(),
        visible: getDateString(date, {
          timeZone: 'America/New_York',
          day: 'numeric',
          month: 'numeric',
          year: '2-digit',
          hour: 'numeric',
        }),
      };
    }
    case 'admin_marketing_emails':
      return value.toString();
    case 'trial_remaining': {
      const license = item.licenses[0];
      if (!license) return { sortable: '', visible: '' };
      const date = new Date(license.end_time);
      return {
        sortable: date.valueOf(),
        visible: daysUntilDate(date),
      };
    }
    case 'license_end': {
      if (item.school_deactivated) return { sortable: '', visible: 'Expired' };
      if (!value) return { sortable: '', visible: '' };
      const date = new Date(value);
      return {
        sortable: date.valueOf(),
        visible: daysUntilDate(date),
      };
    }
    case 'license_type': {
      const plan = getPlanByLicense(value);
      if (!plan) return '';
      return `${plan.type}${plan.licenseTerm === 'trial' ? ' trial' : ''}`;
    }
    default:
      return value === null ? '' : value;
  }
};

export const generateRowData = (columnIds, item) => {
  const columns = {};
  const flatItem = flattenObject(item);
  columnIds.forEach(key => {
    columns[key] = getRowValue(key, flatItem);
  });
  return columns;
};
